module.exports = __webpack_public_path__ + "static/media/pickle_small.f3cf30f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pickle_small.png
// module id = 187
// module chunks = 0